import React from "react";

const Loader = (props) => {
  return (
    <div className={`ripple ${props.additionalClasses || ""}`}>
      <div />
      <div />
    </div>
  )
}

export default Loader;